import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AsideService} from '../../../core/services/aside.service';
import {UrlService} from '../../../core/services/url.service';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'motn-controls',
  templateUrl: './controls.component.html',
  styleUrls: ['./controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterOutlet,
  ],
})
export class ControlsComponent implements OnInit {

  constructor(
    private asideService: AsideService,
  ) {
  }

  ngOnInit(): void {
    this.updateAside();
  }

  private updateAside() {
    this.asideService.replaceContextSections([
      {
        name: 'Controls',
        items: [
          // {
          //   text: 'Dashboard',
          //   path: UrlService.controlsUrls.dashboard,
          // },
          {
            text: 'Hubs',
            path: UrlService.controlsUrls.hubs,
          },
          {
            text: 'Devices',
            path: UrlService.controlsUrls.devices,
          },
          {
            text: 'Tiles',
            path: UrlService.controlsUrls.tiles,
          },
        ],
      },
    ]);
  }

}
